import { useQuery } from '@tanstack/react-query';

import { apiRequest } from 'helpers/api';

import type { MisRestaurant } from 'types/entitlements';

export const MIS_RESTAURANT_QUERY_KEY = 'misRestaurant';

/**
 * GET /api/proxy/marketing-integration/restaurant/{id}
 * Returns provisioning status, entitlement scopes, and SMS registration state.
 *
 * @see https://chownow.atlassian.net/wiki/spaces/MIS/pages/4429873190/RFC+MIS+Plan+and+Entitlement+API+Contracts
 */
export const useGetMisRestaurant = (restaurantId: string | undefined) =>
  useQuery<MisRestaurant | null>({
    queryKey: [MIS_RESTAURANT_QUERY_KEY, restaurantId],
    queryFn: async () => {
      if (!restaurantId) {
        throw new Error('restaurantId is required');
      }

      let httpStatus: number | undefined;

      const { data, error } = await apiRequest<MisRestaurant>({
        path: `proxy/marketing-integration/restaurant/${restaurantId}`,
        trackErrorsInSentry: ({ status }) => status !== 404,
        onError: (response: Response | undefined) => {
          httpStatus = response?.status;
        },
      });

      if (error) {
        if (httpStatus === 404) return null;
        throw error;
      }
      return data;
    },
    enabled: !!restaurantId,
  });
